import { environment } from './environment/environment';
import axios, { AxiosHeaders } from 'axios';

export class Util {
  public static apiPublicUrl(path: string): string {
    return environment.api_url + '/api/public/' + path;
  }

  public static apiAuthUrl(path: string): string {
    return environment.api_url + '/api/auth/' + path;
  }

  public static initAxios(): void {
    // Hot reload re-runs this module; drop the previous interceptors so they never stack
    // (a stacked response interceptor would turn every body into `undefined`).
    const registry = globalThis as typeof globalThis & {
      __lumaAxiosInterceptors?: { request: number; response: number };
    };
    if (registry.__lumaAxiosInterceptors) {
      axios.interceptors.request.eject(registry.__lumaAxiosInterceptors.request);
      axios.interceptors.response.eject(registry.__lumaAxiosInterceptors.response);
    }

    const requestId = axios.interceptors.request.use((req) => {
      //   req.headers.authorization = 'Bearer ' + localStorage.getItem('token');
      (req.headers as AxiosHeaders).set(
        'Authorization',
        'Bearer ' + localStorage.getItem('token')
      );

      return req;
    });

    const responseId = axios.interceptors.response.use(
      function (response) {
        const body = response.data;
        const jwtName = body?.errorData?.name;
        // luma-api verifyToken rejects a bad/expired token with HTTP 200.
        if (
          body?.success === false &&
          body?.errorCode === 0 &&
          (jwtName === 'JsonWebTokenError' ||
            jwtName === 'TokenExpiredError' ||
            body?.errorData?.message === 'Unknown Error') &&
          response.config?.url?.includes('/api/auth/') &&
          !window.location.pathname.startsWith('/sign-in')
        ) {
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = '/sign-in';
        }
        return body;
      },
      function (error) {
        const status = error?.response?.status;
        const body = error?.response?.data;
        // 401/403 on an admin route: the stored token is not an admin's (the
        // web app also runs on localhost:3000 and shares localStorage), so
        // sign in again instead of leaving every page empty.
        if (
          (status === 401 || status === 403) &&
          error?.config?.url?.includes('/api/auth/') &&
          !window.location.pathname.startsWith('/sign-in')
        ) {
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = '/sign-in';
        }
        // Callers show `error` in toasts/dialogs, so keep it a string.
        const message =
          (typeof body?.message === 'string' && body.message) ||
          (typeof body?.error === 'string' && body.error) ||
          error?.message ||
          'Request failed';
        return { success: false, data: undefined, error: message };
      }
    );

    registry.__lumaAxiosInterceptors = { request: requestId, response: responseId };
  }
}

Util.initAxios();
